import { InvoiceQueryFilter } from "@/api/invoiceApi";
import { Popover, Flex } from "@chakra-ui/react";
import { ExportIcon, DownloadIcon } from "@digital-services-gard-as/anchor-icons";
import { Button, Radio, RadioGroup } from "@digital-services-gard-as/anchor-react";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

export const ExportTableList = ({
    invoiceIds,
    queryFilter,
    id,
    handleExport
}: {
    invoiceIds: string[];
    queryFilter: InvoiceQueryFilter;
    id: string;
    handleExport: (invoiceIds?: string[], queryFilter?: InvoiceQueryFilter) => Promise<void>;
}) => {
    const { t } = useTranslation("claimsInvoicesOverview");
    const [exportOption, setExportOption] = useState<string>("all");

    const handleExportInvoices = useCallback(async () => {
        if (exportOption === "current") {
            await handleExport(invoiceIds, queryFilter);
            return;
        }
        await handleExport([], queryFilter);
    }, [exportOption, invoiceIds, queryFilter, handleExport]);

    return (
        <Popover.Root
            positioning={{
                placement: "bottom-end"
            }}
        >
            <Popover.Trigger asChild>
                <Button
                    variant="secondary"
                    data-testid={`${id}-exportBtn`}
                    style={{ width: "fit-content" }}
                    icon={<ExportIcon />}
                >
                    {t("claimsInvoicesOverview:exportInvoices.title")}
                </Button>
            </Popover.Trigger>
            <Popover.Positioner>
                <Popover.Content>
                    <Popover.CloseTrigger />
                    <Flex flexDir="column" m="1rem">
                        <RadioGroup
                            onChange={setExportOption}
                            value={exportOption}
                            data-testid={`${id}-exportRadioGroup`}
                            legend={t("claimsInvoicesOverview:exportInvoices.description")}
                        >
                            <Radio value="all" size="sm">
                                {t("claimsInvoicesOverview:exportInvoices.allInvoices")}
                            </Radio>
                            <Radio value="current" size="sm">
                                {t("claimsInvoicesOverview:exportInvoices.currentInvoices")}
                            </Radio>
                        </RadioGroup>
                        <Button
                            variant="secondary"
                            onClick={handleExportInvoices}
                            data-testid={`${id}-exportDownloadBtn`}
                            icon={<DownloadIcon />}
                        >
                            {t("claimsInvoicesOverview:exportInvoices.download")}
                        </Button>
                    </Flex>
                </Popover.Content>
            </Popover.Positioner>
        </Popover.Root>
    );
};
